/** Приоритет звонков, записи и внешних видеоплееров над музыкой. */
class MediaFocus {
	blockers = $state<string[]>([]);
	claim(owner: string) {
		this.blockers = [...new Set([...this.blockers, owner])];
	}
	release(owner: string) {
		this.blockers = this.blockers.filter((value) => value !== owner);
	}
}
export const mediaFocus = new MediaFocus();
